import React from "react";
import { Navigation } from "../navigation";

const Layout = ({ children, title, subtitle }) => {
  return (
    <div className="dark min-h-screen bg-dark-bg">
      <Navigation />
      
      {/* ページヘッダー */}
      <section className="page-header" style={{ 
        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)',
        paddingTop: '120px',
        paddingBottom: '80px',
        textAlign: 'center'
      }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1 style={{ 
                color: '#f8fafc', 
                fontSize: '48px', 
                fontWeight: '700',
                marginBottom: '20px',
                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)'
              }}>
                {title}
              </h1>
              {subtitle && (
                <p style={{ 
                  color: '#cbd5e1', 
                  fontSize: '20px', 
                  fontWeight: '300',
                  maxWidth: '800px',
                  margin: '0 auto'
                }}>
                  {subtitle}
                </p>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* メインコンテンツ */}
      <main className="main-content">
        {children}
      </main>

      {/* フッター */}
      <footer id="footer">
        <div className="container text-center">
          <p>
            &copy; 2024 All Rights Reserved by{" "}
            <a href="https://deeptell.co.jp" rel="nofollow">
              DeepTeLL
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Layout; 